/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const LinkOut: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14 3C13.4477 3 13 3.44772 13 4C13 4.55228 13.4477 5 14 5H17.5858L10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071C10.6834 14.0976 11.3166 14.0976 11.7071 13.7071L19 6.41421V10C19 10.5523 19.4477 11 20 11C20.5523 11 21 10.5523 21 10V4C21 3.44772 20.5523 3 20 3H14ZM5 8C5 7.44772 5.44772 7 6 7H8C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5H6C4.34315 5 3 6.34315 3 8V18C3 19.6569 4.34315 21 6 21H16C17.6569 21 19 19.6569 19 18V16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16V18C17 18.5523 16.5523 19 16 19H6C5.44772 19 5 18.5523 5 18V8Z'
      fill='currentColor'
    />
  </React.Fragment>
)
